import React, { ReactNode } from "react";

const CreateModal = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div className="fixed top-0 left-0 w-screen h-screen bg-gray-800 bg-opacity-80 flex items-center justify-center z-30 ">
      <div className={`p-4 ${className}`}>{children}</div>
    </div>
  );
};

export { CreateModal };
